__turbopack_context__.v({
  "content": "o-index-module-scss-module__97FQfW__content",
  "expander-button": "o-index-module-scss-module__97FQfW__expander-button",
  "headline": "o-index-module-scss-module__97FQfW__headline",
  "placeholder": "o-index-module-scss-module__97FQfW__placeholder",
  "section": "o-index-module-scss-module__97FQfW__section",
  "section-bg-faded-gray": "o-index-module-scss-module__97FQfW__section-bg-faded-gray",
  "section-bg-white": "o-index-module-scss-module__97FQfW__section-bg-white",
  "section-pbd-3xl": "o-index-module-scss-module__97FQfW__section-pbd-3xl",
  "section-pbd-3xs": "o-index-module-scss-module__97FQfW__section-pbd-3xs",
  "section-pbd-l": "o-index-module-scss-module__97FQfW__section-pbd-l",
  "section-pbd-m": "o-index-module-scss-module__97FQfW__section-pbd-m",
  "section-pbd-none": "o-index-module-scss-module__97FQfW__section-pbd-none",
  "section-pbd-s": "o-index-module-scss-module__97FQfW__section-pbd-s",
  "section-pbd-xl": "o-index-module-scss-module__97FQfW__section-pbd-xl",
  "section-pbd-xs": "o-index-module-scss-module__97FQfW__section-pbd-xs",
  "section-pbd-xxl": "o-index-module-scss-module__97FQfW__section-pbd-xxl",
  "section-pbd-xxs": "o-index-module-scss-module__97FQfW__section-pbd-xxs",
  "section-pbm-3xl": "o-index-module-scss-module__97FQfW__section-pbm-3xl",
  "section-pbm-3xs": "o-index-module-scss-module__97FQfW__section-pbm-3xs",
  "section-pbm-l": "o-index-module-scss-module__97FQfW__section-pbm-l",
  "section-pbm-m": "o-index-module-scss-module__97FQfW__section-pbm-m",
  "section-pbm-none": "o-index-module-scss-module__97FQfW__section-pbm-none",
  "section-pbm-s": "o-index-module-scss-module__97FQfW__section-pbm-s",
  "section-pbm-xl": "o-index-module-scss-module__97FQfW__section-pbm-xl",
  "section-pbm-xs": "o-index-module-scss-module__97FQfW__section-pbm-xs",
  "section-pbm-xxl": "o-index-module-scss-module__97FQfW__section-pbm-xxl",
  "section-pbm-xxs": "o-index-module-scss-module__97FQfW__section-pbm-xxs",
  "section-ptd-3xl": "o-index-module-scss-module__97FQfW__section-ptd-3xl",
  "section-ptd-3xs": "o-index-module-scss-module__97FQfW__section-ptd-3xs",
  "section-ptd-l": "o-index-module-scss-module__97FQfW__section-ptd-l",
  "section-ptd-m": "o-index-module-scss-module__97FQfW__section-ptd-m",
  "section-ptd-none": "o-index-module-scss-module__97FQfW__section-ptd-none",
  "section-ptd-s": "o-index-module-scss-module__97FQfW__section-ptd-s",
  "section-ptd-xl": "o-index-module-scss-module__97FQfW__section-ptd-xl",
  "section-ptd-xs": "o-index-module-scss-module__97FQfW__section-ptd-xs",
  "section-ptd-xxl": "o-index-module-scss-module__97FQfW__section-ptd-xxl",
  "section-ptd-xxs": "o-index-module-scss-module__97FQfW__section-ptd-xxs",
  "section-ptm-3xl": "o-index-module-scss-module__97FQfW__section-ptm-3xl",
  "section-ptm-3xs": "o-index-module-scss-module__97FQfW__section-ptm-3xs",
  "section-ptm-l": "o-index-module-scss-module__97FQfW__section-ptm-l",
  "section-ptm-m": "o-index-module-scss-module__97FQfW__section-ptm-m",
  "section-ptm-none": "o-index-module-scss-module__97FQfW__section-ptm-none",
  "section-ptm-s": "o-index-module-scss-module__97FQfW__section-ptm-s",
  "section-ptm-xl": "o-index-module-scss-module__97FQfW__section-ptm-xl",
  "section-ptm-xs": "o-index-module-scss-module__97FQfW__section-ptm-xs",
  "section-ptm-xxl": "o-index-module-scss-module__97FQfW__section-ptm-xxl",
  "section-ptm-xxs": "o-index-module-scss-module__97FQfW__section-ptm-xxs",
});
